module.exports = __webpack_public_path__ + "static/img/dsk-contact-bg1.a7dc121.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/dsk-contact-bg1.jpg
// module id = 228
// module chunks = 1